import { render, staticRenderFns } from "./nuxt-ssr-instantsearch.vue?vue&type=template&id=70f744e9&scoped=true&lang=pug&"
import script from "./nuxt-ssr-instantsearch.vue?vue&type=script&lang=coffee&"
export * from "./nuxt-ssr-instantsearch.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f744e9",
  null
  
)

export default component.exports